import { useTranslation } from "next-i18next";
import Link from "next/link";
import { useAppContext } from "@/src/config/AppProvider";
import styled from "styled-components";

const Branches = () => {
  const { branches } = useAppContext();
  const { t } = useTranslation();

  return (
    <div className="rbt-category-menu-wrapper rbt-category-update">
      <div className="rbt-category-btn">
        <div className="rbt-offcanvas-trigger md-size icon">
          <span className="d-none d-xl-block">
            <i className="feather-grid"></i>
          </span>
          <i title="Category" className="feather-grid d-block d-xl-none"></i>
        </div>
        <span className="category-text d-xl-block">{t("branches")}</span>
      </div>

      <StyledDropdown className="update-category-dropdown">
        <div className="inner">
          <ul className="dropdown-parent-wrapper">
            {branches?.map(branch => (
              <li key={branch.IdGuid} className="dropdown-parent-list">
                <Link href={branch.Website} target="_blank">
                  {branch.Name}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </StyledDropdown>
    </div>
  );
};

const StyledDropdown = styled.div`
  @media (max-width: 768px) {
    left: -120px !important;
  }
`;

export default Branches;
